import { useEffect } from "react";

import { batch, useDispatch, useSelector } from "react-redux";

import { usePrevious } from "app/components/hooks/usePrevious";

import { revealLimitReachedModalToggledAction, tableRowsSelectionChangedAction } from "../../store/action-creators";
import {
    selectRemainingQuota,
    selectRevealLimitReachedModalPayload,
    selectSelectedContacts,
} from "../../store/selectors";

import RevealLimitReachedModal from "./RevealLimitReachedModal";

const RevealLimitReachedModalContainer = () => {
    const dispatch = useDispatch();
    const modalPayload = useSelector(selectRevealLimitReachedModalPayload);
    const remainingRevealQuota = useSelector(selectRemainingQuota);
    const selectedContacts = useSelector(selectSelectedContacts);
    const prevSelectedContacts = usePrevious(selectedContacts);

    useEffect(() => {
        const selectedUnrevealedContacts = selectedContacts.filter((e) => !e.isRevealed);

        if (selectedUnrevealedContacts.length > remainingRevealQuota) {
            dispatch(
                revealLimitReachedModalToggledAction({
                    isOpened: true,
                    lastValidSelection: prevSelectedContacts ?? [],
                }),
            );
        }
    }, [selectedContacts]);

    function handleClose() {
        batch(() => {
            dispatch(tableRowsSelectionChangedAction(modalPayload.lastValidSelection));
            dispatch(
                revealLimitReachedModalToggledAction({
                    isOpened: false,
                    lastValidSelection: [],
                }),
            );
        });
    }

    return (
        <RevealLimitReachedModal
            isOpened={modalPayload.isOpened}
            onClose={handleClose}
        />
    );
};

export default RevealLimitReachedModalContainer;
